import { memo } from "react";

type Props = {
	label: string;
	value: string | React.ReactNode;
};

export const ManagementECReceiptDetailVoucherIssuedSectionLabelAndTitleItem = memo(({ label, value }: Props) => {
	return (
		<div>
			<p className="text-sm text-zinc-500">{label}</p>
			<div>{typeof value === "string" ? <p>{value}</p> : value}</div>
		</div>
	);
});

ManagementECReceiptDetailVoucherIssuedSectionLabelAndTitleItem.displayName =
	"ManagementECReceiptDetailVoucherIssuedSectionLabelAndTitleItem";
